import programData from './programfinder.service';
import scholarshipData from './scholarships.service';
import contentService from './content.service';
import capsService from './caps.service';

const moduleName = 'usc.core.services';

angular.module(moduleName, [])
    .factory('programService', ['$http', programData])
    .factory('scholarshipsService', ['$http', scholarshipData])
    .factory('contentService', ['$http', contentService])
    .factory('capsService', ['$http', capsService]);

export default moduleName;